import { getChipIndexFromWeight } from '../../../utils/chips';
import { useCoreSelector } from '../../CoreStore';

import type { ChipValueType } from './types';

export const useChipSlice = {
  getSelectedChip: (): ChipValueType => {
    return useCoreSelector((state) => {
      const chips = state.chips.chips;
      const selectedChipWeight = state.chips.selectedChip?.weight;
      const selectedChipFromConfig = state.config.playerConfig?.selectedChipIndex;
      // Fallback for invalid selected chip in player config
      const selectedChipFromConfigFallback =
        selectedChipFromConfig && selectedChipFromConfig <= chips.length ? selectedChipFromConfig : 0;

      const selectedChipIndex = selectedChipWeight
        ? getChipIndexFromWeight(selectedChipWeight)
        : selectedChipFromConfigFallback;

      return chips[selectedChipIndex];
    });
  },
  getChips: (): ChipValueType[] => {
    return useCoreSelector((state) => state.chips.chips);
  },
  getAreChipsReady: (): boolean => {
    return useCoreSelector((state) => state.chips.chipsReady);
  },
};
